import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/src/locale/fr'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
    theme: {      
        themes: {
            light: {
                primary: '#334668',
                secondary: '#456089',
                tertiary: '#436085',
                light: '#7d8eff',
                closewhite: '#FAFBFD',
                accent: '#8c9eff',
                error: '#b71c1c',
                green: '#1adc77',
                gray: '#8E9FB5',
                orange: '#FF8E06',
                blue: '#3A61F7',
                alert: '#00D357',
                background: '#041F3D',
                disabled: '#BAC5D3'
            },
            dark: {
                primary: '#0038c3',
                secondary: '#000018',
                accent: '#000018',
                error: '#000018',
            }
        },
    },
    lang: {
        locales: { fr },
        current: 'fr',
    }
});
